import { useState, useRef } from "react";
import { useDesktop } from "../hooks";
import { dataSet } from "../data/suggestedcourses";
import {
  BsFillArrowRightSquareFill,
  BsFillArrowLeftSquareFill,
} from "react-icons/bs";
import "../styles/suggestedcourses.css";

interface Props {
  heading: string;
}

const SuggestedCourses = ({ heading }: Props) => {
  const suggestedcourse = dataSet.map((course, i) => (
    <div
      key={i}
      className="suggested-course-card"
    >
      <img
        src={course.banner}
        alt="course"
      />
      <div>
        <h3>{course.title}</h3>
        <p>{course.durationViews}</p>
        <p>{course.price}</p>
      </div>
    </div>
  ));

  let scrl = useRef<HTMLDivElement>(null);
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion

  const slide = (shift: number) => {
    if (null !== scrl.current) {
      scrl.current.scrollLeft += shift;
      setscrollX(scrollX + shift);
    }
  };

  const scrollCheck = () => {
    if (null !== scrl.current) {
      setscrollX(scrl.current.scrollLeft);
    }
  };

  return (
    <aside className="suggested-courses">
      <div className="suggested-courses-arrow">
        <h2>{heading}</h2>
        {useDesktop() >= 1024 && (
          <div>
            <BsFillArrowLeftSquareFill
              onClick={() => slide(-120)}
              style={{
                fontSize: "2em",
                color: "var(--vidomCustomBlue)",
                marginLeft: "1em",
                cursor: "pointer",
                opacity: scrollX <= 0 ? 0.3 : 1,
              }}
              className="suggested-courses-arrow-left"
            />
            <BsFillArrowRightSquareFill
              onClick={() => slide(+120)}
              style={{
                fontSize: "2em",
                color: "var(--vidomCustomBlue)",
                cursor: "pointer",
                marginLeft: "1em",
              }}
              className="suggested-courses-arrow-right"
            />
          </div>
        )}
      </div>

      <div
        className="suggested-courses-container"
        ref={scrl}
        onScroll={scrollCheck}
      >
        {suggestedcourse}
        {suggestedcourse}
      </div>
    </aside>
  );
};

export default SuggestedCourses;
